import { styled } from '@mui/material/styles';
import { ListItemButton } from '@mui/material';
import { ArrowForwardIos } from '@mui/icons-material';

export const StyledListItemButton = styled(ListItemButton)(({ theme }) => ({
  borderRadius: theme.spacing(1),
  paddingTop: 0,
  paddingBottom: 0,
  marginBottom: theme.spacing(1),
  '&:hover': {
    backgroundColor: theme.palette.action.hover
  }
}));

export const StyledArrowIcon = styled(ArrowForwardIos)(({ theme }) => ({
  marginRight: theme.spacing(2),
  fontSize: '1rem',
  color: theme.palette.ui.accent
}));